import { Authentication, i18n, router } from "./utils"
import { ClientTable, ServerTable } from "vue-tables-2"
import { capitalize, isDefined } from "./assets/libs/utils"
import { get, last } from "lodash"
import App from "./App"
import BootstrapVue from "bootstrap-vue"
import PrettyCheckbox from "pretty-checkbox-vue"
import Toasted from "vue-toasted"
import ToggleButton from "vue-js-toggle-button"
import VeeValidate from "vee-validate" // form validation
import Vue from "vue"
import axios from "axios"
import moment from "moment"
import momentDurationFormatSetup from "moment-duration-format"
import { store } from "./store/store"

momentDurationFormatSetup(moment)

// register plug-in
Vue.use(ToggleButton)
Vue.use(Authentication)
Vue.use(Toasted)
Vue.use(BootstrapVue)
Vue.use(PrettyCheckbox)
Vue.use(VeeValidate, { fieldsBagName: "veeFields" })

// Tables
let options = {
  perPage: 10,
  filterable: false,
  debounce: 500,
  requestKeys: {
    query: "fuzzy_search",
    limit: "page_size",
    orderBy: "ordering",
  },
  showChildRowToggler: false,
  skin: "table",  // check tables.scss
  sortIcon: {
    base: "empty-icon",
    is: "empty-icon",
    up: "fas fa-arrow-up",
    down: "fas fa-arrow-down"
  },
  texts: {
    filterPlaceholder: `${i18n.t("search")}...`,
  },
  pagination: {
    dropdown: false,
  }
}

Vue.use(ServerTable, options, false, "bootstrap4")
Vue.use(ClientTable, options, false, "bootstrap4")

// Register a toast with custom options
const toastOptions = {
  position: "bottom-right",
  duration: 10000,
  keepOnHover: true,
  action : {
    text : "dismiss",
    onClick : (e, toastObject) => {
      toastObject.goAway(0)
    }
  },
}
Vue.toasted.register("toast", message => message, toastOptions)

Vue.config.productionTip = false

export const apiHost = process.env.VUE_APP_API_HOST || "localhost"
export const protocol = process.env.VUE_APP_PROTOCOL || "http"

// requests handlers configuration
let hdr = "Origin, Accept, Content-Type, Authorization,"
hdr += " Access-Control-Allow-Origin"

axios.defaults.baseURL = protocol + "://" + apiHost + "/api/"
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*"
axios.defaults.headers.common["Access-Control-Allow-Headers"] = hdr

Vue.prototype.$http = axios

// Vue app configuration
Vue.prototype.$config = {
  VERSION: get(process.env, "VUE_APP_VERSION"),
  GOOGLE_RECAPTCHA_SITE_KEY: get(process.env, "VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY"),
  SOUNDSYS_TEMPLATE_URL: "/templates/soundsys_repertoire_template_v1_4.xlsx",
}

/******************/
/*  LOGIN CONFIG  */
/******************/

const openEndPoints = [
  "get_auth_token/",
  "users/login/",
  "countries/",
  "societies/",
  "members/signup/",
  "users/recovery/"
]

const openEndPointStartsWith = ["languages/?organization"]

axios.interceptors.request.use(
  function (request) {
    store.commit("soundsys/waiting", true)

    const isGetRequest = (request.method === "get")
    const hasParams  = (request.params !== undefined)

    if (isGetRequest && hasParams) {
      const [urlWithoutQuery, ...params] = request.url.split("?")

      // add slash before query params
      // to fix redirections issue in safari
      if (last(urlWithoutQuery) !== "/") {
        request.url = [urlWithoutQuery, "/?", ...params].join("")
      }
    }

    let accessToken = localStorage.getItem("access_token")
    let lang = localStorage.getItem("lang")

    request.headers.common["Accept-Language"] = lang ? lang : "en"

    if (openEndPoints.includes(request.url)) {
      return request
    } else if (
      openEndPointStartsWith.some(function (x) {
        return request.url.startsWith(x)
      })
    ) {
      return request
    } else if (accessToken) {
      request.headers.common["Authorization"] = "Bearer " + accessToken
      return request
    } else {
      router.push({ name: "welcome" })
    }
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  function (response){
    store.commit("soundsys/waiting", false)
    return response
  }, function (error){
    store.commit("soundsys/waiting", false)
    if (error.response && error.response.status === 404) {
      store.commit("soundsys/setPageNotFound", true)
    }
    return Promise.reject(error)
  }
)
export const EventBus = new Vue()

export const api = axios

/* GLOBAL FILTERS */

Vue.filter("capitalize", capitalize)
Vue.filter("isDefined", isDefined)
Vue.filter("moment", moment)
Vue.filter("transformDate", (timestamp, format) => timestamp ? moment(timestamp).format(format) : "")
Vue.filter("normalizeSeconds", function (seconds) {
  if (!seconds) return ""

  const duration = moment.duration(Number(seconds), "seconds")
  let time = duration.format("HH:mm:ss")

  if (time == 0) return ""
  if (duration.asMinutes() < 1) return "00:" + time

  return time
})
Vue.filter("toSeconds", function (duration) {
  if(!duration.length) return null
  const timeSegments = duration.split(":")

  // add minute and hour segments if not preseent
  while (timeSegments.length < 3) {
    timeSegments.unshift("00")
  }

  // add leading zero
  const paddedTimeSegments = timeSegments.map(segment => segment.padStart(2, "0"))
  const timeSegmentString = paddedTimeSegments.join(":")

  if(moment(timeSegmentString, "HH:mm:ss", true).isValid()) {
    return moment.duration(timeSegmentString).asSeconds()
  }

  return "invalid"
})

Vue.filter("getPercentageValue", function (percent) {
  if (!percent) return
  return Number(percent.match(/\d+/g)[0])
})

Vue.filter("upper", function (value) {
  if (!value) return ""
  value = value.toString()
  return value.toUpperCase()
})

Vue.filter("getPercentageValue", function (percent) {
  if (!percent) return
  return Number(percent.match(/\d+/g)[0])
})

Vue.filter("get", function (...args) {
  return get(...args)
})

Vue.filter("getTypeName", function (code, srTypes) {
  const current = srTypes.find(type => type.code === code)
  if (current) return current.type
})

Vue.filter("decamelize", function (string) {
  return string
    .replace(/([a-z\d])([A-Z])/g, "$1" + " " + "$2")
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1" + " " + "$2")
    .toLowerCase()
})

/* eslint-disable no-new */
export const app = new Vue({
  el: "#app",
  i18n,
  store, // inject store to all children
  router,
  components: {
    App
  },
  template: "<App/>"
})
